import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import "../common/elements/Header.scss";
import translate from "src/i18n/translate";
export default function UnauthorizedComponent() {
    return (_jsxs("main", { className: "main-content-home unauth-component", children: [_jsx("div", { className: "unauthorized-title", children: translate("app.unauthorized.title") }), _jsx("div", { className: "unauth-desc", children: translate("app.unauthorized.description") })] }));
}
